module.exports = __webpack_public_path__ + "img/3.cleaned_shower.c2673b61.svg";